/**
 * @mynaui/icons-react v0.3.1 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var Star = createReactComponent("star", "Star", [["path", { "d": "M12.854 3.5a.979.979 0 0 0-1.708 0 26.978 26.978 0 0 0-2.057 4.762c-.139.431-.551.73-1.023.743a29.398 29.398 0 0 0-4.267.425c-.774.136-1.065 1.018-.515 1.556a31.484 31.484 0 0 0 3.41 2.892c.367.269.518.73.378 1.152a26.807 26.807 0 0 0-1.14 4.927c-.1.755.708 1.288 1.41.928a28.593 28.593 0 0 0 3.98-2.472 1.148 1.148 0 0 1 1.356 0 28.505 28.505 0 0 0 3.98 2.472c.701.36 1.51-.173 1.41-.928a26.81 26.81 0 0 0-1.14-4.928c-.14-.42.01-.882.378-1.151a31.497 31.497 0 0 0 3.41-2.892c.55-.538.26-1.42-.515-1.556a29.046 29.046 0 0 0-4.267-.425 1.097 1.097 0 0 1-1.023-.743 26.982 26.982 0 0 0-2.057-4.761", "key": "svg-0" }]]);

export { Star as default };
//# sourceMappingURL=Star.js.map
